import React from 'react';
import Img from 'gatsby-image';
import { ImageWrapper, StyledImage } from './image.styled';
var Image = function Image(_ref) {
    var fluid = _ref.fluid, imageUrl = _ref.imageUrl, alt = _ref.alt;
    return /*#__PURE__*/ React.createElement(ImageWrapper, null, fluid ? /*#__PURE__*/ React.createElement(Img, {
        fluid: fluid,
        alt: alt
    }) : /*#__PURE__*/ React.createElement(StyledImage, {
        src: imageUrl,
        alt: alt
    }));
};
export default Image;
